export default __webpack_public_path__ + "static/media/conjure.e0cbf69f.png";